import React, { createContext, useState, useEffect, useContext } from 'react';
import { auth } from '../firebaseConfig';
import { onAuthStateChanged, signOut } from 'firebase/auth';

// Crée le contexte
const AuthContext = createContext();

// Crée un "hook" personnalisé pour utiliser facilement le contexte
export const useAuth = () => {
    return useContext(AuthContext);
};

// Crée le fournisseur qui enveloppera notre application
export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [userRole, setUserRole] = useState(null);
    const [loading, setLoading] = useState(true);

    // Fonction de déconnexion
    const logout = () => {
        return signOut(auth);
    };

    // Cet effet s'exécute au démarrage et écoute les changements d'état de connexion
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            setCurrentUser(user);
            if (user) {
                try {
                    const token = await user.getIdTokenResult();
                    const role = token.claims.role || null;
                    setUserRole(role);
                    setIsAdmin(role === 'admin');
                } catch {
                    setUserRole(null);
                    setIsAdmin(false);
                }
            } else {
                setUserRole(null);
                setIsAdmin(false);
            }
            setLoading(false);
        });

        return unsubscribe; // Nettoie l'écouteur lorsque le composant est démonté
    }, []);

    const value = {
        currentUser,
        isAdmin,
        userRole,
        logout
    };

    // Ne rend les enfants que lorsque l'état de connexion a été vérifié
    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};
